/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppointmentTypeDto,
  CreateAppointmentTypeRequestDto,
  ErrorResponse,
  UpdateAppointmentTypeRequestDto,
} from '../models/index';
import {
    AppointmentTypeDtoFromJSON,
    AppointmentTypeDtoToJSON,
    CreateAppointmentTypeRequestDtoFromJSON,
    CreateAppointmentTypeRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UpdateAppointmentTypeRequestDtoFromJSON,
    UpdateAppointmentTypeRequestDtoToJSON,
} from '../models/index';

export interface CreateAppointmentTypeRequest {
    createAppointmentTypeRequestDto: CreateAppointmentTypeRequestDto;
}

export interface DeleteAppointmentTypeRequest {
    id: string;
}

export interface UpdateAppointmentTypeRequest {
    id: string;
    updateAppointmentTypeRequestDto: UpdateAppointmentTypeRequestDto;
}

/**
 * 
 */
export class AppointmentTypeApi extends runtime.BaseAPI {

    /**
     * Creates a new appointment type
     * Create a new appointment type
     */
    async createAppointmentTypeRaw(requestParameters: CreateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentTypeDto>> {
        if (requestParameters['createAppointmentTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAppointmentTypeRequestDto',
                'Required parameter "createAppointmentTypeRequestDto" was null or undefined when calling createAppointmentType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/appointment/types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAppointmentTypeRequestDtoToJSON(requestParameters['createAppointmentTypeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new appointment type
     * Create a new appointment type
     */
    async createAppointmentType(requestParameters: CreateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentTypeDto> {
        const response = await this.createAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an appointment type
     * Delete appointment type
     */
    async deleteAppointmentTypeRaw(requestParameters: DeleteAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAppointmentType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/appointment/types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an appointment type
     * Delete appointment type
     */
    async deleteAppointmentType(requestParameters: DeleteAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAppointmentTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all appointment types
     * Get appointment types
     */
    async getAppointmentTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/appointment/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentTypeDtoFromJSON));
    }

    /**
     * Retrieves all appointment types
     * Get appointment types
     */
    async getAppointmentTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentTypeDto>> {
        const response = await this.getAppointmentTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing appointment type
     * Update appointment type
     */
    async updateAppointmentTypeRaw(requestParameters: UpdateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentTypeDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAppointmentType().'
            );
        }

        if (requestParameters['updateAppointmentTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAppointmentTypeRequestDto',
                'Required parameter "updateAppointmentTypeRequestDto" was null or undefined when calling updateAppointmentType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/appointment/types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAppointmentTypeRequestDtoToJSON(requestParameters['updateAppointmentTypeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeDtoFromJSON(jsonValue));
    }

    /**
     * Updates an existing appointment type
     * Update appointment type
     */
    async updateAppointmentType(requestParameters: UpdateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentTypeDto> {
        const response = await this.updateAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
